import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';

export default [
  {
    path: '/IFPageNinetyThreePreLogin',
    name: 'IFPageNinetyThreePreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetyThree/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (from.path === '/IFPageNinetyThreeLogin' || from.path === '/IFPageNinetyThreeLoginSecond') {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageNinetyThreeLogin',
    name: 'pageNinetyThreeLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetyThree/login.vue'),
  },
  {
    path: '/IFPageNinetyThreeLeaveInfo',
    name: 'pageNinetyThreeLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetyThree/leaveInfo.vue'),
  },
  {
    path: '/IFPageNinetyThreeResult',
    name: 'pageNinetyThreeResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageNinetyThree/result.vue'),
  },
  {
    path: '/IFPageNinetyThreeLoading',
    name: 'pageNinetyThreeLoading',
    component: () => import('@/pages/pageListAll/pageNinetyThree/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageNinetyThreeLoginSecond',
    name: 'pageNinetyThreeLoginSecond',
    component: () => import('@/pages/pageListAll/pageNinetyThree/loginSecond.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageNinetyThreeOnline',
    name: 'pageNinetyThreeOnline',
    component: () => import('@/pages/pageListAll/pageNinetyThree/online.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageNinetyThreeLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageNinetyThreeGuide',
    name: 'pageNinetyThreeLoginGuide',
    component: () => import('@/pages/pageListAll/pageNinetyThree/guide.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageNinetyThreeCar',
    name: 'pageNinetyThreeCar',
    component: () => import('@/pages/pageListAll/pageNinetyThree/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageNinetyThreeCarDetails',
    name: 'pageNinetyThreeCarDetails',
    component: () => import('@/pages/pageListAll/pageNinetyThree/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageNinetyThreeBlank',
    name: 'pageNinetyThreeBlank',
    component: () => import('@/pages/pageListAll/pageNinetyThree/blank.vue'),
    meta: {
      title: '星贷',
    },
  },
];
